/** @format */
import React from 'react';

export default ({onPress, children}) => {
  return React.cloneElement(children, {onPress});
};
